import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import RestHelper from "../../../Helper/RestHelper";

@Component({
  selector: 'app-kontakt',
  templateUrl: './kontakt.component.html',
  styleUrl: './kontakt.component.css'
})
export class KontaktComponent implements OnInit {

  public contactForm: FormGroup = this.formBuilder.group({
    name: ["", [Validators.required, Validators.pattern('^[a-zA-Z\\s]+$'), Validators.minLength(4)]],
    email: ["", [Validators.required, Validators.email]],
    phone: ["", Validators.minLength(4)],
    subject: ["", [Validators.required, Validators.minLength(4)]],
    message: ["", [Validators.required, Validators.minLength(4)]]
  })

  public sentstatus: number = 0

  private buttontext = "Absenden"
  private id = "senden"
  private zeit = 10

  constructor(private http: HttpClient, private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    document.getElementById("senddiv")!.classList.remove("hidden");
    this.buttonsperre();
  }

  private buttonsperre() {

    if (document.getElementById(this.id) === null) return;

    const button = <HTMLButtonElement>document.getElementById(this.id);

    button.disabled = true
    button.innerHTML = this.buttontext + " (" + this.zeit + ")";
    if (this.zeit > 0) {
      this.zeit--
      setTimeout(() => {
        this.buttonsperre()
      }, 1000)
    } else {
      button.disabled = false
      button.innerHTML = this.buttontext
      button.classList.remove("nocursor");
    }
  }

  public onSubmit() {
    if (!this.contactForm.valid) {
      console.log("Form Invalid")
      this.contactForm.markAllAsTouched()
      return;
    }

    const body = new FormData();
    body.append("name", this.contactForm.value.name)
    body.append("email", this.contactForm.value.email)
    body.append("phone", this.contactForm.value.phone)
    body.append("subject", this.contactForm.value.subject)
    body.append("message", this.contactForm.value.message)

    this.http.post(RestHelper.API_BASE_URL + 'submitContactForm', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          this.sentstatus = 1
          this.contactForm.reset()
        },
        error: (err) => {
          this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
          console.error(err)
        }
      });
  }

  public getFormControls() {
    return this.contactForm.controls;
  }
}
